import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-4">
      <SEOHead
        title="页面未找到 - 第一版主"
        description="抱歉，您访问的页面不存在。请返回首页或浏览我们的其他内容。"
        keywords="第一版主,论坛管理,版主培训"
        canonicalUrl="https://diyibanzhu.com/404"
      />
      <div className="text-center">
        <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-primary-100/70">
          <i className="ri-compass-discover-line text-4xl text-primary-600"></i>
        </div>
        <h1 className="font-heading text-6xl font-bold text-primary-500 mb-2">404</h1>
        <h2 className="font-heading text-xl font-semibold text-foreground-900 mb-3">页面未找到</h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-md">
          抱歉，您访问的页面可能已被移除、更名或暂时不可用。
        </p>
        <Link
          to="/"
          className="inline-flex px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors cursor-pointer"
        >
          <i className="ri-home-line mr-2"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}